export default {
  filename: 'history-wall',
  dataURL: '/service.php',
  regions: ['APAC', 'CHINA', 'GERMANY', 'JAPAN', 'LATAM', 'NWE', 'SEEMEA', 'Total IO'],
  fields: ['Diabetes', 'Insulin', 'GLP1', 'MOAD'],
  load () {
    let self = this
    fetch(this.dataURL + '?action=get').then(function (response) {
      return response.json()
    }).then(function (data) {
      self.setLocalData(data)
    })
  },

  setState (state) {
    console.log('set state: ', state)
  },

  async saveData () {
    // Default options are marked with *
    await fetch(this.dataURL + '?action=store', {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // no-referrer, *client
      body: window.localStorage.getItem(this.filename) // body data type must match "Content-Type" header
    })
      .then((res) => {
        console.log(res)
        this.setState({
          transferState: {
          /* State changes */
          }
        })
      })
      .catch(err => this.setState({ error: err }))
  },

  regionData (data, name, fieldName) {
    if (data) {
      let region = data.find(region => region.name === name)
      if (region) {
        let field = region
          .fields
          .find(field => field.name === fieldName)
        if (field) {
          return field.value
        }
      }
    }
  },

  setRegionData (name, fieldName, newValue) {
    let self = this
    let data = self.getLocalData()

    if (data) {
      let region = data.chart.data.find(region => region.name === name)
      if (region) {
        let field = region
          .fields
          .find(field => field.name === fieldName)
        if (field) {
          field.value = newValue
          self.setLocalData(data)
        }
      }
    }
  },

  setDataSource (newSource) {
    let data = this.getLocalData()
    if (data) {
      data.chart.dataSource = newSource
      this.setLocalData(data)
    }
  },

  getLocalData () {
    let data = JSON.parse(window.localStorage.getItem(this.filename))
    return data || {}
  },

  setLocalData (data) {
    if (data) {
      window.localStorage.setItem(this.filename, JSON.stringify(data))
    }
  },

  setUpdateDate () {
    let data = this.getLocalData()
    if (data) {
      let updDate = new Date()
      data.lastupdate = updDate
      this.setLocalData(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/dataSetup.js